import { createContext } from "react";

const DrawerContext = createContext({
  drawerState: false,
  setDrawerState: () => { },
});

export default DrawerContext;